var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeroMotif36145Ce0(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 589,
    height: 509,
    viewBox: "0 0 589 509",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11063_26518)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M872 506.201L283.725 -504.161",
    stroke: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.422 545.548L216.147 -464.813",
    stroke: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736.84 584.896L148.565 -425.465",
    stroke: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.262 624.244L80.9867 -386.117",
    stroke: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.594 326.804L675.912 169.413",
    stroke: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.434 593.867L612.655 206.243L432.512 -139.83L254.802 -487.32L283.726 -504.161L479.818 -167.374L675.909 169.413L872.001 506.201L721.434 593.867Z",
    fill: "#DCDCDC",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.398 543.817L572.381 229.694L402.78 -122.517L80.9907 -386.117L283.729 -504.16L479.821 -167.373L675.913 169.414L872.004 506.201L807.398 543.817Z",
    fill: "#FAFAFA",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.447 226.743C575.818 223.944 572.227 222.996 569.428 224.626C566.629 226.255 565.681 229.846 567.311 232.645C568.94 235.445 572.531 236.393 575.33 234.763C578.129 233.133 579.077 229.543 577.447 226.743Z",
    fill: "#FAFAFA",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.172 653.99L534.262 251.886L453.597 -152.107L107.749 -401.699L283.726 -504.161L479.817 -167.374L675.909 169.413L872.001 506.201L618.172 653.99Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.33 248.935C537.7 246.136 534.11 245.188 531.311 246.818C528.511 248.447 527.563 252.038 529.193 254.837C530.823 257.637 534.414 258.585 537.213 256.955C540.012 255.325 540.96 251.735 539.33 248.935Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.526 647.38L603.735 211.437L231.125 -22.5739L98.2881 -396.19L283.726 -504.16L479.818 -167.373L675.91 169.414L872.001 506.201L629.526 647.38Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.474 643.917L609.683 207.974L393.858 -117.323L21.2485 -351.334L283.728 -504.161L479.819 -167.374L675.911 169.413L872.003 506.201L635.474 643.917Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.384 578.758L536.154 250.785L363.851 -99.8528L213.173 -463.081L283.726 -504.16L479.817 -167.373L675.909 169.414L872.001 506.201L747.384 578.758Z",
    fill: "#F0F5F3",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.225 247.833C539.595 245.034 536.004 244.086 533.205 245.716C530.406 247.346 529.458 250.936 531.088 253.736C532.718 256.535 536.308 257.483 539.108 255.853C541.907 254.223 542.855 250.633 541.225 247.833Z",
    fill: "#F0F5F3",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.462 589.775L502.635 270.301L377.096 -107.565L226.148 -470.636L283.726 -504.161L479.817 -167.374L675.909 169.413L872.001 506.201L728.462 589.775Z",
    fill: "#3878f4",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.705 267.35C506.075 264.55 502.485 263.602 499.686 265.232C496.886 266.862 495.938 270.453 497.568 273.252C499.198 276.051 502.789 276.999 505.588 275.37C508.387 273.74 509.335 270.149 507.705 267.35Z",
    fill: "#3878f4",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.098 637.15L615.089 204.826L330.333 -80.3364L232.097 -474.099L283.728 -504.161L479.819 -167.374L675.911 169.413L872.002 506.201L647.098 637.15Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.258 647.537L474.525 286.67L424.135 -134.951L159.112 -431.603L283.729 -504.16L479.82 -167.373L675.912 169.414L872.004 506.201L629.258 647.537Z",
    fill: "#FBE8E7",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.592 283.719C477.962 280.919 474.372 279.971 471.572 281.601C468.773 283.231 467.825 286.821 469.455 289.621C471.085 292.42 474.675 293.368 477.475 291.738C480.274 290.109 481.222 286.518 479.592 283.719Z",
    fill: "#FBE8E7",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.18 636.52L438.572 307.603L397.373 -119.369L201.281 -456.156L283.729 -504.161L479.82 -167.374L675.912 169.414L872.004 506.201L648.18 636.52Z",
    fill: "#3878f4",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.643 304.651C442.013 301.852 438.422 300.904 435.623 302.534C432.824 304.164 431.876 307.754 433.506 310.554C435.136 313.353 438.726 314.301 441.525 312.671C444.325 311.041 445.273 307.451 443.643 304.651Z",
    fill: "#3878f4",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.578 656.666L432.895 310.908L278.432 -50.1174L274.537 -498.809L283.727 -504.16L479.819 -167.373L675.911 169.414L872.002 506.201L613.578 656.666Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.963 307.957C436.333 305.157 432.743 304.209 429.943 305.839C427.144 307.469 426.196 311.06 427.826 313.859C429.456 316.658 433.047 317.606 435.846 315.977C438.645 314.347 439.593 310.756 437.963 307.957Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.805 529.022L426.135 314.843L340.874 -86.4746L270.75 -496.606L283.726 -504.16L479.817 -167.373L675.909 169.414L872.001 506.201L832.805 529.022Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.205 311.891C429.575 309.092 425.985 308.144 423.186 309.774C420.386 311.404 419.438 314.994 421.068 317.794C422.698 320.593 426.289 321.541 429.088 319.911C431.887 318.281 432.835 314.691 431.205 311.891Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M752.253 575.925L509.666 266.209L440.084 -144.237L106.67 -401.07L283.729 -504.161L479.82 -167.374L675.912 169.413L872.004 506.201L752.253 575.925Z",
    fill: "#8CB3FF",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.737 263.258C513.107 260.458 509.516 259.51 506.717 261.14C503.918 262.77 502.97 266.361 504.6 269.16C506.229 271.959 509.82 272.907 512.619 271.278C515.418 269.648 516.366 266.057 514.737 263.258Z",
    fill: "#8CB3FF",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.945 609.292L610.766 207.345L320.603 -74.6703L99.9125 -397.135L283.729 -504.16L479.821 -167.373L675.912 169.414L872.004 506.201L694.945 609.292Z",
    fill: "#252117",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.942 615.115L484.525 280.846L245.723 -31.0731L66.9316 -377.933L283.727 -504.16L479.819 -167.373L675.91 169.414L872.002 506.201L684.942 615.115Z",
    fill: "#252117",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.592 277.895C487.962 275.096 484.372 274.148 481.572 275.777C478.773 277.407 477.825 280.998 479.455 283.797C481.085 286.597 484.675 287.545 487.475 285.915C490.274 284.285 491.222 280.694 489.592 277.895Z",
    fill: "#252117",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.349 522.884L665.639 175.394L400.346 -121.101L127.213 -413.031L283.728 -504.16L479.819 -167.373L675.911 169.414L872.003 506.201L843.349 522.884Z",
    fill: "#F9F9F9",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M847.132 520.681L416.404 320.509L347.092 -90.0946L71.7971 -380.766L283.727 -504.16L479.818 -167.373L675.91 169.414L872.002 506.201L847.132 520.681Z",
    fill: "#252117",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.475 317.558C419.845 314.758 416.254 313.81 413.455 315.44C410.656 317.07 409.708 320.66 411.338 323.46C412.968 326.259 416.558 327.207 419.358 325.577C422.157 323.948 423.105 320.357 421.475 317.558Z",
    fill: "#252117",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.117 662.175L466.144 291.549L394.939 -117.953L108.291 -402.014L283.728 -504.161L479.819 -167.374L675.911 169.414L872.003 506.201L604.117 662.175Z",
    fill: "#252117",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.213 288.598C469.583 285.798 465.993 284.85 463.193 286.48C460.394 288.11 459.446 291.7 461.076 294.5C462.706 297.299 466.297 298.247 469.096 296.617C471.895 294.988 472.843 291.397 471.213 288.598Z",
    fill: "#252117",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.742 655.407L635.635 192.865L338.985 -85.3729L89.0998 -390.839L283.729 -504.161L479.821 -167.374L675.912 169.413L872.004 506.201L615.742 655.407Z",
    fill: "#226AF5",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.197 578.286L460.197 295.011L269.782 -45.0808L232.368 -474.256L283.728 -504.16L479.82 -167.373L675.911 169.414L872.003 506.201L748.197 578.286Z",
    fill: "#F9F9F9",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.268 292.06C463.638 289.261 460.047 288.313 457.248 289.943C454.449 291.572 453.501 295.163 455.131 297.962C456.761 300.762 460.351 301.71 463.15 300.08C465.95 298.45 466.898 294.86 465.268 292.06Z",
    fill: "#F9F9F9",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.98 581.905L523.722 258.024L215.719 -13.6027L21.5196 -351.491L283.728 -504.161L479.82 -167.374L675.912 169.413L872.003 506.201L741.98 581.905Z",
    fill: "#3878f4",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.791 255.073C527.161 252.274 523.571 251.326 520.772 252.956C517.972 254.586 517.024 258.176 518.654 260.976C520.284 263.775 523.875 264.723 526.674 263.093C529.473 261.463 530.421 257.873 528.791 255.073Z",
    fill: "#3878f4",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.72 630.382L674.287 170.358L250.047 -33.5913L209.929 -461.193L283.726 -504.16L479.818 -167.373L675.909 169.414L872.001 506.201L658.72 630.382Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M867.948 508.561L499.934 271.875L248.157 -32.4896L77.2045 -383.914L283.728 -504.16L479.819 -167.373L675.911 169.414L872.003 506.201L867.948 508.561Z",
    fill: "#383429",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.002 268.924C503.372 266.124 499.782 265.176 496.982 266.806C494.183 268.436 493.235 272.027 494.865 274.826C496.495 277.625 500.086 278.573 502.885 276.944C505.684 275.314 506.632 271.723 505.002 268.924Z",
    fill: "#383429",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.774 550.585L652.935 182.792L254.645 -36.2669L203.173 -457.258L283.728 -504.16L479.82 -167.373L675.912 169.414L872.003 506.201L795.774 550.585Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.148 563.176L406.404 326.332L264.376 -41.9331L81.5304 -386.432L283.728 -504.161L479.82 -167.374L675.912 169.413L872.003 506.201L774.148 563.176Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.475 323.381C409.845 320.582 406.254 319.633 403.455 321.263C400.656 322.893 399.708 326.484 401.338 329.283C402.968 332.082 406.558 333.031 409.358 331.401C412.157 329.771 413.105 326.18 411.475 323.381Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835.511 527.448L438.303 307.76L258.971 -38.7852L231.288 -473.627L283.729 -504.16L479.821 -167.373L675.913 169.414L872.004 506.201L835.511 527.448Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.373 304.809C441.743 302.01 438.153 301.061 435.354 302.691C432.554 304.321 431.606 307.912 433.236 310.711C434.866 313.51 438.457 314.459 441.256 312.829C444.055 311.199 445.003 307.608 443.373 304.809Z",
    fill: "white",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11063_26518"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1306,
    height: 391,
    fill: "white",
    transform: "translate(657.18 778.332) rotate(-120.21)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroMotif36145Ce0);
export default __webpack_public_path__ + "static/media/heroMotif.36145ce0.ad575b59c89ad44038195fcc0fa69f9d.svg";
export { ForwardRef as ReactComponent };